import { render } from "./SponsorList.vue?vue&type=template&id=7472eb3c&scoped=true"
import script from "./SponsorList.vue?vue&type=script&lang=js"
export * from "./SponsorList.vue?vue&type=script&lang=js"

import "./SponsorList.vue?vue&type=style&index=0&id=7472eb3c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7472eb3c"]])

export default __exports__